interface PopupProps {
	close: any
}
const Popup: React.FC<PopupProps> = ({ close, children }) => {
	return (
		<section className="transition duration-150 ease-in-out fixed top-0 left-0 w-full h-full bg-black/30 z-20">
			<div className="w-96 absolute left-1/2 top-1/2  -translate-x-1/2 -translate-y-1/2 p-8 text-center">
				<img
					src={process.env.PUBLIC_URL + "/images/icon-close.png"}
					alt="Menu"
					loading="lazy"
					width="83"
					height="73"
					className=" w-[83px] cursor-pointer absolute top-4 right-4 z-10"
					onClick={close}
				/>
				{children}
			</div>
		</section>
	)
}

export default Popup
